// extracted by mini-css-extract-plugin
module.exports =  {"text":"text--pJmEF","hidden":"hidden--AL7GH","counter":"counter--s55HL"};